<script setup>
import {onMounted, ref, watch} from "vue";
import {debounce, isEmpty} from "lodash";
import {usePiniaStore} from "../store/pinia_store";
import {storeToRefs} from "pinia";

const props = defineProps({
  incrementalOrderQuantity: {
    type: Number,
    required: true,
  },
  minimumOrderQuantity: {
    type: Number,
    required: true,
  },
  eventBus: {
    type: Object,
    required: true,
  },
  crmId: {
    type: String,
    required: true,
  },
  initialQuantity: {
    type: Number,
    required: false,
  }
})

const piniaStore = usePiniaStore();
const {cart} = storeToRefs(piniaStore);

const quantity = ref(props.initialQuantity ?? props.minimumOrderQuantity);

watch(quantity, debounce(() => {
  props.eventBus.$emit('set-quantity', {
    quantity: quantity.value,
    crmId: props.crmId
  });

  props.eventBus.$emit('quantity-changed', {
    quantity: quantity.value,
    crmId: props.crmId
  });
}, 250), {deep: true, immediate: true})

watch(() => piniaStore.isLoading, () => {
  if (!isEmpty(cart.value.lines?.[props.crmId] ?? null) && !piniaStore.isLoading) {
    quantity.value = cart.value.lines[props.crmId].quantity;
  }
}, {deep: true, immediate: true})
</script>

<template>
  <div class="vue-product-quantity">
    <dentaid-number-input
      v-if="!piniaStore.isLoading"
      v-model="quantity"
      :min="minimumOrderQuantity"
      :step="incrementalOrderQuantity"
      size="small"
      inline
      controls
      :inputtable="false"
    ></dentaid-number-input>
  </div>
</template>
